import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, Instagram, Facebook } from "lucide-react";
import { Logo } from "@/components/Logo";

export const BrandHeaderNav = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const links = [
    { to: "/events", label: "Events" },
    { to: "/services", label: "Lanes" },
    { to: "/products", label: "Products" },
    { to: "/artists", label: "Artists" },
    { to: "/sponsorships", label: "Sponsorships" },
    { to: "/vendors", label: "Vendors" },
    { to: "/company", label: "Company" },
  ];
  const go = (to) => { setOpen(false); navigate(to); };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black">
      <div className="mx-auto grid h-20 max-w-[1400px] grid-cols-[1fr_auto_1fr] items-center px-5 sm:px-8">
        <Link to="/" className="flex items-center" data-testid="brand-home-link">
          <Logo className="h-12 sm:h-14" />
        </Link>
        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={`font-cond text-[13px] font-semibold uppercase tracking-[0.18em] transition-colors hover:text-white ${pathname.startsWith(l.to) ? "text-white" : "text-neutral-400"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden items-center justify-end gap-5 md:flex">
          <a href="#" aria-label="Instagram" className="text-neutral-400 hover:text-white"><Instagram className="h-5 w-5" /></a>
          <a href="#" aria-label="Facebook" className="text-neutral-400 hover:text-white"><Facebook className="h-5 w-5" /></a>
          <button data-testid="nav-get-tickets-btn" onClick={() => navigate("/request")} className="btn-chrome px-5 py-2.5 text-[12px]">Start a Request</button>
        </div>
        <button className="col-start-3 justify-self-end text-white md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-black px-6 py-6 md:hidden">
          {links.map((l) => (
            <button key={l.to} onClick={() => go(l.to)} className="block w-full py-3 text-left font-cond text-lg uppercase tracking-[0.14em] text-neutral-200">{l.label}</button>
          ))}
          <button onClick={() => go("/request")} className="btn-gold mt-4 w-full py-3.5 text-sm">Start a Request</button>
        </div>
      )}
    </header>
  );
};
